import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Hero } from '@xingternal/typography';

import * as S from './landing-hero.styles';

export const LandingHero: React.VFC = () => {
  return (
    <S.HeroWrapper>
      <Hero sizeConfined="large">
        <FormattedMessage id="JOBS_LANDING_LO_HERO" />
      </Hero>
      <S.MarketingIllustration />
    </S.HeroWrapper>
  );
};
